export const PERMISSIONS = {
  superAdmin: [
    'manageUsers',
    'manageRoles',
    'systemSettings',
    'accessAuditLogs',
    'overrideComplianceFlags',
    'fullAccess',
  ],
  complianceOfficer: [
    'viewTransactions',
    'flagSuspiciousActivity',
    'approveKYCAML',
    'accessCustomerProfiles',
    'generateComplianceReports',
    'manageBlacklists',
  ],
  kycAgent: [
    'viewKYCDocuments',
    'approveRejectKYC',
    'updateCustomerProfiles',
    'viewTransactionHistory',
  ],
  transactionManager: [
    'viewTransactions',
    'retryFailedTransactions',
    'suspendTransactions',
    'approveLargeTransactions',
    'managePayoutRules',
  ],
  audit: [
    'viewAllTransactions',
    'viewLogs',
    'downloadAuditReports',
    'viewUserActivities',
  ],
  technical: [
    'manageAPIKeys',
    'monitorSystemHealth',
    'accessDevOpsLogs',
    'updateWebhooks',
    'manageConfiguration',
  ],
  customerSupport: [
    'viewCustomerProfiles',
    'viewTransactions',
    'initiateRefunds',
    'resetUserCredentials',
    'createSupportTickets',
  ],
};
